// export const API = 'http://localhost:8000/api'
// export const API = 'http://192.168.1.8:8000/api'
// export const API = 'https://backend.geldtechsensor.com/api'
export const API = 'https://geld-backend.vercel.app/api'